"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _logOut = require("../actions/authentication/logOut");

var _helpers = require("../helpers");

var _excluded = ["component", "location", "logOut"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      location = _ref.location,
      logOut = _ref.logOut,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var authToken = (0, _helpers.getAuthToken)();

  if (!authToken || authToken === '0') {
    logOut();
  }

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: function render(props) {
      return authToken && authToken !== '0' ? /*#__PURE__*/_react["default"].createElement(Component, props) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: location
          }
        }
      });
    }
  }));
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    logOut: _logOut.logOut
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PrivateRoute);

exports["default"] = _default;